import React from "react"
import VersusPage from "../../templates/hotels/VersusPage"

const Page = () => <VersusPage duelKey="borgoVsComo" locale="en" />

export default Page
